export const EMPTY_PROFILE = {
  displayName: "",
  professionalRole: "",
  timezone: "Europe/Moscow",
  locale: "ru",
  onboardingStep: 1,
  onboardingComplete: false,
  services: [{ title: "", description: "", active: true }],
  notifications: {
    digestFrequency: "daily",
    immediateLeads: false,
    productUpdates: true,
  },
  plan: "free",
  limits: { niches: 1 },
};

export function editableProfile(profile) {
  return {
    ...EMPTY_PROFILE,
    ...profile,
    displayName: profile?.displayName || "",
    professionalRole: profile?.professionalRole || "",
    services: profile?.services?.length
      ? profile.services
      : EMPTY_PROFILE.services.map((service) => ({ ...service })),
    notifications: {
      ...EMPTY_PROFILE.notifications,
      ...(profile?.notifications || {}),
    },
    limits: { ...EMPTY_PROFILE.limits, ...(profile?.limits || {}) },
  };
}

export function profilePayload(profile, { onboardingStep, completeOnboarding = false } = {}) {
  return {
    displayName: profile.displayName,
    professionalRole: profile.professionalRole,
    timezone: profile.timezone,
    locale: profile.locale,
    onboardingStep: onboardingStep || profile.onboardingStep || 1,
    completeOnboarding,
    services: profile.services.filter((service) => service.title.trim()),
    notifications: profile.notifications,
  };
}
